@if (magMenuTonen() && menuType) {
    @switch (menuType) {
        @case ('causal') {
            <nodemenu-causal [node]="node" [cy]="cy" />
        }
        @case ('configuration') {
            <nodemenu-configuration [node]="node" [cy]="cy" />
        }
        @case ('correspondence_qs') {
            <nodemenu-correspondence [node]="node" [cy]="cy" correspondentieType="qs" />
        }
        @case ('correspondence_qv') {
            <nodemenu-correspondence [node]="node" [cy]="cy" correspondentieType="qv" />
        }
        @case ('correspondence_dqs') {
            <nodemenu-correspondence [node]="node" [cy]="cy" correspondentieType="dqs" />
        }
        @case ('correspondence_dv') {
            <nodemenu-correspondence [node]="node" [cy]="cy" correspondentieType="dv" />
        }
        @case ('d_calc') {
            <nodemenu-d-calc [node]="node" [cy]="cy" />
        }
        @case ('d_ineq') {
            <nodemenu-d-ineq [node]="node" [cy]="cy" />
        }
        @case ('derivative') {
            <nodemenu-derivative [node]="node" [cy]="cy" />
        }
        @case ('derivative_plus_min') {
            <nodemenu-derivative-plus-min [node]="node" [cy]="cy" />
        }
        @case ('derivative_zero') {
            <nodemenu-derivative-zero [node]="node" [cy]="cy" />
        }
        @case ('entity_agent') {
            <nodemenu-entity-agent [node]="node" [cy]="cy" />
        }
        @case ('q_calc') {
            <nodemenu-q-calc [node]="node" [cy]="cy" />
        }
        @case ('q_exo') {
            <nodemenu-q-exo [node]="node" [cy]="cy" />
        }
        @case ('q_ineq') {
            <nodemenu-q-ineq [node]="node" [cy]="cy" />
        }
        @case ('quantity') {
            <nodemenu-quantity [node]="node" [cy]="cy" />
        }
        @case ('quantity_space') {
            <nodemenu-quantity-space [node]="node" [cy]="cy" />
        }
        @case ('quantity_space_interval') {
            <nodemenu-quantity-space-interval [node]="node" [cy]="cy" />
        }
        @case ('quantity_space_point') {
            <nodemenu-quantity-space-point [node]="node" [cy]="cy" />
        }
    }
}
